export enum OrderTypeOnlineEnum {
  online = 'online'
}
